/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs */

const en_gc_search_guides_gridcraft_online_sections_6_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troubleshoot a workbook mismatch`)
};

const zh_gc_search_guides_gridcraft_online_sections_6_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排查工作簿差异`)
};

/**
* | output |
* | --- |
* | "Troubleshoot a workbook mismatch" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_6_links_0_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_6_Links_0_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_6_links_0_label(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_6_links_0_label(inputs)
});
export { gc_search_guides_gridcraft_online_sections_6_links_0_label as "gc.search_guides.gridcraft_online.sections.6.links.0.label" }